import { LoginResponse } from "@core/models/api.response";
import { userCredentialsDTO } from "@core/models/dto.models";
import { createActionGroup, props } from "@ngrx/store";

export const loginActions = createActionGroup({
  source: "login",
  events: {
    "Request Login": props<userCredentialsDTO>(),
    "Request Login Success": props<LoginResponse>(),
    "Request Login Failed": props<LoginResponse>(),
  },
});
